"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tab = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const shared_styles_1 = require("@/stylesheets/shared.styles");
const utils_1 = require("@/utils");
let Tab = class Tab extends lit_1.LitElement {
    render() {
        return (0, lit_1.html) `
      <div class="tab-content">
        <slot></slot>
      </div>
    `;
    }
    constructor() {
        super();
        this.value = '';
        /** @internal 선택 값을 소유한 mm-tab-list가 채운다. */
        this.active = false;
        /** @internal 선택 값을 소유한 mm-tab-list가 채운다. */
        this.ariaSelected = 'false';
        this.handleClick = () => {
            this.focus();
            this.select();
        };
        // role·tabindex·focus를 host가 가지므로 클릭도 host에서 받는다.
        // 리스너 대상이 host 자신이라 연결이 바뀌어도 유지되므로 생성자에서 한 번만 등록한다.
        this.addEventListener('click', this.handleClick);
    }
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute('role', 'tab');
    }
    select() {
        (0, utils_1.emit)(this, 'tab-select', { value: this.value });
    }
    updated(changedProperties) {
        if (!changedProperties.has('active'))
            return;
        this.ariaSelected = this.active ? 'true' : 'false';
    }
};
Tab.styles = (0, lit_1.css) `
    :host {
      position: relative;
      display: inline-flex;
      flex-shrink: 0;

      --tab-height: var(--size-32);
      --tab-padding-inline: var(--space-3);
      --tab-text-size: var(--font-size-14);
      --tab-text-color: var(--foreground-subtle-color);
    }

    .tab-content {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      height: var(--tab-height);
      padding: 0 var(--tab-padding-inline);
      white-space: nowrap;
      font-size: var(--tab-text-size);
      color: var(--tab-text-color);
      cursor: pointer;
      user-select: none;
      transition: color var(--transition-duration) var(--transition-easing),
        font-weight var(--transition-duration) var(--transition-easing);
    }

    :host([aria-selected='true']) {
      --tab-text-color: var(--interaction-selected-foreground-color);
    }

    :host(:focus-visible) {
      ${shared_styles_1.focusRingStyles};
    }

    /* 부모 탭리스트가 pill 형태일 때 활성화된 글자 색상을 커스텀하고 싶다면 하단 주석 해제 */
    /* :host-context(mm-tab-list[variant="pill"])[active] { color: var(--interaction-selected-foreground-color); } */
  `;
__decorate([
    (0, decorators_js_1.property)({ type: String })
], Tab.prototype, "value", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean, reflect: true })
], Tab.prototype, "active", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'aria-selected', reflect: true })
], Tab.prototype, "ariaSelected", void 0);
Tab = __decorate([
    (0, decorators_js_1.customElement)('mm-tab')
], Tab);
exports.Tab = Tab;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGFiLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsidGFiLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLDZCQUEyQztBQUMzQyxxREFBMkQ7QUFJM0QsK0RBQTZEO0FBQzdELG1DQUE4QjtBQUd2QixJQUFNLEdBQUcsR0FBVCxNQUFNLEdBQUksU0FBUSxnQkFBVTtJQThDakMsTUFBTTtRQUNKLE9BQU8sSUFBQSxVQUFJLEVBQUE7Ozs7S0FJVixDQUFBO0lBQ0gsQ0FBQztJQUVEO1FBQ0UsS0FBSyxFQUFFLENBQUE7UUFoQm1CLFVBQUssR0FBRyxFQUFFLENBQUE7UUFDdEMsNENBQTRDO1FBQ0EsV0FBTSxHQUFHLEtBQUssQ0FBQTtRQUMxRCw0Q0FBNEM7UUFDMkIsaUJBQVksR0FDakYsT0FBTyxDQUFBO1FBMEJELGdCQUFXLEdBQUcsR0FBRyxFQUFFO1lBQ3pCLElBQUksQ0FBQyxLQUFLLEVBQUUsQ0FBQTtZQUNaLElBQUksQ0FBQyxNQUFNLEVBQUUsQ0FBQTtRQUNmLENBQUMsQ0FBQTtRQWpCQyxrREFBa0Q7UUFDbEQsb0RBQW9EO1FBQ3BELElBQUksQ0FBQyxnQkFBZ0IsQ0FBQyxPQUFPLEVBQUUsSUFBSSxDQUFDLFdBQVcsQ0FBQyxDQUFBO0lBQ2xELENBQUM7SUFFRCxpQkFBaUI7UUFDZixLQUFLLENBQUMsaUJBQWlCLEVBQUUsQ0FBQTtRQUN6QixJQUFJLENBQUMsWUFBWSxDQUFDLE1BQU0sRUFBRSxLQUFLLENBQUMsQ0FBQTtJQUNsQyxDQUFDO0lBRU0sTUFBTTtRQUNYLElBQUEsWUFBSSxFQUFDLElBQUksRUFBRSxZQUFZLEVBQUUsRUFBRSxLQUFLLEVBQUUsSUFBSSxDQUFDLEtBQUssRUFBRSxDQUFDLENBQUE7SUFDakQsQ0FBQztJQU9TLE9BQU8sQ0FBQyxpQkFBdUM7UUFDdkQsSUFBSSxDQUFDLGlCQUFpQixDQUFDLEdBQUcsQ0FBQyxRQUFRLENBQUM7WUFBRSxPQUFNO1FBRTVDLElBQUksQ0FBQyxZQUFZLEdBQUcsSUFBSSxDQUFDLE1BQU0sQ0FBQyxDQUFDLENBQUMsTUFBTSxDQUFDLENBQUMsQ0FBQyxPQUFPLENBQUE7SUFDcEQsQ0FBQzs7QUE5RU0sVUFBTSxHQUFHLElBQUEsU0FBRyxFQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztRQWdDYiwrQkFBZTs7Ozs7R0FLcEIsQ0FBQTtBQUMyQjtJQUEzQixJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLENBQUM7a0NBQVc7QUFFTTtJQUEzQyxJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsT0FBTyxFQUFFLE9BQU8sRUFBRSxJQUFJLEVBQUUsQ0FBQzttQ0FBZTtBQUVhO0lBQXRFLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsU0FBUyxFQUFFLGVBQWUsRUFBRSxPQUFPLEVBQUUsSUFBSSxFQUFFLENBQUM7eUNBQzdEO0FBNUNFLEdBQUc7SUFEZixJQUFBLDZCQUFhLEVBQUMsUUFBUSxDQUFDO0dBQ1gsR0FBRyxDQWdGZjtBQWhGWSxrQkFBRyJ9